<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="bar"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'StackedBarCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    colorsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: [],
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              show: false,
              total: {
                enabled: false,
                offsetX: 0,
                style: {
                  fontSize: '10px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        xaxis: {
          categories: [],
          labels: {
            formatter(val) {
              return `${val}`
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
          show: false,
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${val} ₺`
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
          position: 'top',
          horizontalAlign: 'center',
          offsetX: 0,
          offsetY: 0,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.chartOptions.colors = this.colorsData
    },
  },
}
</script>
